import { Card, Skeleton, Stack } from '@mui/material';

export default function RouteSkeleton() {
  return (
    <Card sx={{ p: 2, mb: 2, borderRadius: 3 }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="rectangular" width="60%" height={20} />
        </Stack>

        <Skeleton variant="rectangular" width="40%" height={20} />

        <Skeleton variant="rectangular" width="100%" height={12} />

        <Stack direction="row" spacing={2} alignItems="center">
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="rectangular" width="60%" height={20} />
        </Stack>

        <Skeleton variant="rectangular" width="30%" height={16} />
      </Stack>
    </Card>
  );
}
